// extracted by mini-css-extract-plugin
export default {"labelDescriptionTooltip":"Label-module__labelDescriptionTooltip--Tv8up"};